/* ============================================================================
   OC SUBSCRIPTION PLAN FIX v1  —  Operator Coffee, 2026-09-27
   File: assets/oc-subscription-plan-fix.js
   Rollback: remove this file AND its one <script> line in layout/theme.liquid.

   PROBLEM
   Bold subscriptions appends a hidden <input name="selling_plan"> to every
   product form each time its widget initialises, but with no duplicate check.
   It then writes the selected plan using form.querySelector(), which matches
   only the FIRST such input. Every later duplicate stays empty.
   Form fields are last-value-wins, so the trailing empty duplicate overrides
   the real plan: the POST goes out carrying both, Shopify drops the plan, and
   the subscriber is added at full price (the reported bug).

   FIX
   Before the theme builds FormData, collapse each product form to exactly one
   selling_plan field carrying the chosen plan. Runs in the capture phase, so it
   settles before product-form.js's own submit handler reads the form.
   Deliberately independent of Bold internals: survives app updates.
   ============================================================================ */
(function () {
  'use strict';

  var VERSION = 'oc-sub-plan-fix/v1';
  var FORM_SELECTOR = 'form[action*="/cart/add"]';
  var FIELD = 'input[name="selling_plan"]';

  function isProductForm(el) {
    return !!el && el.nodeName === 'FORM' && typeof el.matches === 'function' && el.matches(FORM_SELECTOR);
  }

  /* Collapse a form's selling_plan controls to a single field holding the
     customer's actual selection. Last non-empty value wins: an empty control
     means "one-time", a filled one means "subscribe". */
  function normalize(form) {
    if (!form || typeof form.querySelectorAll !== 'function') return;
    var inputs = form.querySelectorAll(FIELD);
    if (inputs.length === 0) return;

    var chosen = '';
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value) chosen = inputs[i].value;
    }

    if (inputs.length === 1) {
      if (inputs[0].value !== chosen) inputs[0].value = chosen;
      return;
    }

    inputs[0].value = chosen;
    for (var j = inputs.length - 1; j >= 1; j--) {
      if (inputs[j].parentNode) inputs[j].parentNode.removeChild(inputs[j]);
    }
  }

  function normalizeAll(root) {
    var scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    var forms = scope.querySelectorAll(FORM_SELECTOR);
    for (var i = 0; i < forms.length; i++) normalize(forms[i]);
  }

  /* Load-bearing: capture phase on document precedes the target-phase submit
     handler that product-form.js attaches to the form itself, so FormData is
     built from an already-corrected form. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (isProductForm(form)) normalize(form);
  }, true);

  /* Hygiene: keep the DOM clean so Bold's own sync keeps reading/writing the
     surviving control, and so back/forward cache restores stay consistent. */
  document.addEventListener('DOMContentLoaded', function () { normalizeAll(document); });
  window.addEventListener('pageshow', function () { normalizeAll(document); });

  if (window.console && console.debug) console.debug(VERSION + ' armed');
})();
